import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { NewOrderApi } from '../api/newOrderApi';
import { ExportRequest } from '../types';

export const QUERY_KEY_EXPORT_REQUESTS = 'export-requests';
export const useExportRequests = (
  orderId: number,
  options?: Partial<
    UseQueryOptions<ExportRequest[], AxiosError, ExportRequest[]>
  >,
) =>
  useQuery<ExportRequest[], AxiosError>({
    queryKey: [QUERY_KEY_EXPORT_REQUESTS, orderId],
    queryFn: () => NewOrderApi.exportRequests(orderId),
    ...options,
  });
